var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ClaimHelpComponent } from '@app/shared/modals/claim-help/claim-help.component';
import { environment } from '../../../environments/environment';
import { UtilService, ErrorMessageService, LOCAL_VAR } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(modalService, router, route, authenticationService, formBuilder, toastrService, errormessageservice, utilService) {
        var _this = this;
        this.modalService = modalService;
        this.router = router;
        this.route = route;
        this.authenticationService = authenticationService;
        this.formBuilder = formBuilder;
        this.toastrService = toastrService;
        this.errormessageservice = errormessageservice;
        this.utilService = utilService;
        this.isLoading = false;
        this.appname = environment.name;
        this.applogo = environment.logo;
        this.logo = environment.logo;
        this.fileClaim = environment.fileClaim;
        this.credentials$ = new EventEmitter();
        this.route.queryParams.pipe().subscribe(function (params) {
            _this.queryParams = params;
        });
        this.createForm();
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        var domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
        this.applogo = "assets/images/dowc-logo-green-bg.jpg";
        this.logo = "assets/images/dowc-logo.png";
        if (domainconfig) {
            if (domainconfig.appLogo) {
                this.applogo = domainconfig.appLogo;
            }
            if (domainconfig.appLogo) {
                this.logo = domainconfig.appLogo;
            }
            if (domainconfig.appName) {
                this.appname = domainconfig.appName;
            }
        }
        this.utilService.clearMissedError();
    };
    ForgotPasswordComponent.prototype.ngAfterViewInit = function () {
        this.utilService.updateDomainCss();
    };
    ForgotPasswordComponent.prototype.createForm = function () {
        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(/^(\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)]]
        });
    };
    ForgotPasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        this.isLoading = true;
        this.authenticationService
            .forgotPassword(this.forgotPasswordForm.value)
            .pipe(finalize(function () {
            _this.forgotPasswordForm.markAsPristine();
            _this.isLoading = false;
        }))
            .subscribe(function (res) {
            _this.toastrService.info('Email sent successfully!..');
            _this.forgotPasswordForm.reset();
            _this.errormessageservice.clear();
            _this.utilService.clearMissedError();
            _this.router.navigate(['/login']);
        }, function (error) {
            _this.isLoading = false;
        });
    };
    ForgotPasswordComponent.prototype.openHelpPopup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalService.open(ClaimHelpComponent)];
                    case 1:
                        modalRef = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ForgotPasswordComponent;
}());
export { ForgotPasswordComponent };
